/**
 * Canal de déploiement : `prod` (défaut) ou `preprod`.
 * Défini au build par la variable d'environnement `VITE_CHANNEL`
 * (Cloudflare Pages : variable propre au projet de préprod — docs/ARCHITECTURE.md §3).
 * En préprod, le mode debug est actif sans `?debug`.
 */
export type Channel = 'prod' | 'preprod';

const raw = (import.meta.env.VITE_CHANNEL as string | undefined)?.toLowerCase();
export const CHANNEL: Channel = raw === 'preprod' ? 'preprod' : 'prod';
export const IS_PREPROD = CHANNEL === 'preprod';

/** Clé du déblocage du mode debug par **code** (v0.55.3, A115) : `'1'` quand le bon code a été saisi dans les Notes de dev. */
export const DEBUG_UNLOCK_KEY = 'diceordie.debug.unlocked';

/** Le mode debug a-t-il été débloqué par code sur cet appareil ? */
export function debugUnlockedByCode(): boolean {
  try {
    return typeof localStorage !== 'undefined' && localStorage.getItem(DEBUG_UNLOCK_KEY) === '1';
  } catch {
    return false;
  }
}

export function debugEnabledByChannel(): boolean {
  return import.meta.env.DEV || IS_PREPROD || window.location.search.includes('debug') || debugUnlockedByCode();
}
